import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var uploadRes;
export const uploadTodo = createAsyncThunk('upload', async (file) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    var bodyFormData = new FormData()

    bodyFormData.append(
        "file", file
    )

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'upload_image',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return uploadRes = res.data
    } catch (error) {
        return uploadRes = error.response.data
    }
})